module.exports = __webpack_public_path__ + "static/media/copyright.45ef28fb.svg";